var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2988_7423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.333 32C25.1696 32 32.333 24.8366 32.333 16C32.333 7.16344 25.1696 0 16.333 0C7.49645 0 0.333008 7.16344 0.333008 16C0.333008 24.8366 7.49645 32 16.333 32Z",
    fill: "#3C5A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6745 4.91992H17.1301C15.0267 4.91992 12.6872 5.80457 12.6872 8.85348C12.6975 9.91583 12.6872 10.9333 12.6872 12.0783H10.2539V15.9504H12.7625V27.0976H17.3722V15.8769H20.4148L20.69 12.0674H17.2928C17.2928 12.0674 17.3004 10.3729 17.2928 9.88074C17.2928 8.67587 18.5465 8.74487 18.6219 8.74487C19.2185 8.74487 20.3785 8.74661 20.6762 8.74487V4.91992H20.6745Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2988_7423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook_logo.d0170acaca6accab3cd42c1c43869c65.svg";
export { ForwardRef as ReactComponent };